import styled from "styled-components";

// Dropdown Modal Styles
export const DropdownModalContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  padding: 12px;
  z-index: 1000;
  min-width: 200px;
  max-width: 280px;
  box-shadow: 0 1px 7px 0px rgba(0, 0, 0, 0.2);
`;

export const DropdownContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const RadioButtonContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RadioButtonSelected = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #008cff;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RadioButtonInner = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #008cff;
`;

export const RadioButtonUnselected = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #757575;
  background: transparent;
`;

export const OptionText = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2em;
  color: #000000;
  white-space: nowrap;
`;

export const SeparatorLine = styled.div`
  height: 1px;
  background: #d8d8d8;
  width: 100%;
`;

export const DownloadButtonContainer = styled.div`
  margin-top: 16px;
`;

export const DownloadButton = styled.button`
  width: 100%;
  height: 32px;
  background: linear-gradient(
    135deg,
    rgba(83, 178, 254, 1) 0%,
    rgba(6, 90, 243, 1) 100%
  );
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 900;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Enhanced Links Section Styles
export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px 0;
  flex-wrap: wrap;
`;

export const LinkContainer = styled.div`
  position: relative;
`;

export const DropdownToggle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  cursor: pointer;
`;

export const DropdownArrow = styled.svg<{ isOpen: boolean }>`
  width: 16px;
  height: 16px;
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.2s ease;
`;

export const LinkSeparator = styled.div`
  width: 1px;
  height: 14px;
  background: #757575;
  opacity: 0.6;
`;
